// Utility Functions
import { getAccessToken } from './session';

// Utility Packages
import axios from 'axios';

export default function API(method, endPoint, data, isFormData = false) {
  return axios({
    method: method,
    url: endPoint,
    headers: {
      ...(isFormData && { 'Content-Type': 'multipart/form-data' }),
      Authorization: `Bearer ${getAccessToken()}`
    },
    data: data,
    params: data && data.params ? data.params : null
  });
}

export { API };
